module.exports = __webpack_public_path__ + "static/plotter-setup-b94ae5491be6a4afdf1895f2e8b3a1e0.jpg";